export type { SearchResultProps } from './search-result';
export { default as SearchResult } from './search-result';
